import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Divider, Grid, Typography, useTheme } from '@mui/material'
import { useWatch } from 'react-hook-form'
import { useInstallationForm, useInstallationIsGerman } from 'src/Libs/flow/installation/hooks'
import { useFetchSmartMeterGateway } from 'src/Libs/flow/advanced-settings/overview'
import { formatSki } from 'src/Libs/flow/advanced-settings/utils/format-ski'
import { useFetchEebusInfoFromEmc } from '../hooks'

import { Paper } from '@e3dc-react/shell/Elements/Paper'

/** A box with information abour an Eebus (title, shipId, ski) */
export const EmcInfoForEebus: React.FC = () => {
  const { t } = useCustomTranslation()
  const theme = useTheme()

  const isGerman = useInstallationIsGerman()

  const { control } = useInstallationForm()
  const installationId = useWatch({ control, name: 'id' })
  const emcId = useWatch({ control, name: 'emcDevice.deviceId' })

  const { data: eebusInfo } = useFetchEebusInfoFromEmc(installationId ?? undefined, emcId)
  const { data: smartMeterGatewayInfo } = useFetchSmartMeterGateway(installationId ?? undefined, emcId)

  const showInfo = !!(emcId && installationId !== null && eebusInfo)

  if (!showInfo) return null

  /** For German installations, do not show this info if smart-meter-gateway is active. */
  if (isGerman && smartMeterGatewayInfo?.smartMeterGateway?.active) {
    return null
  }

  return (
    <Paper title={t('installation.evseEditor.emcInformationTitle')}>
      <Divider sx={{ borderColor: theme.palette.divider }} />

      <Grid container sx={{ py: 2, spacing: 2 }}>
        <Grid item xs={12} lg={6} xl={4}>
          <Typography variant="caption" component={'p'}>
            {t('common.name')}
          </Typography>
          <Typography>{eebusInfo.deviceName}</Typography>
        </Grid>

        <Grid item xs={12} lg={6} xl={4}>
          <Typography variant="caption" component={'p'}>
            {t('installation.evseEditor.shipId')}
          </Typography>
          <Typography>{eebusInfo.shipId}</Typography>
        </Grid>

        <Grid item xs={12} lg={6} xl={4}>
          <Typography variant="caption" component={'p'}>
            {t('installation.evseEditor.ski')}
          </Typography>
          <Typography>{formatSki(eebusInfo.ski)}</Typography>
        </Grid>
      </Grid>
    </Paper>
  )
}
